import { useState, useEffect } from 'react'
import { apiQuery } from '../services/backendApi'
import { loginDomain } from '../services/login'

const createDeviceLoginToken = () => {
  return new Promise((resolve, reject) => {
    apiQuery('/authenticated', { createDeviceLoginToken: 'true', loginRealm: loginDomain })
      .then(resp => {
        resolve(resp)
      })
  })
}

const checkIfDeviceCodeValid = (fetchCode) => {
  return new Promise((resolve, reject) => {
    apiQuery('/authenticated', { isCodeValid: fetchCode }
    )
      .then(resp => {
        resolve(resp)
      })
  })
}

const loginWithDeviceCode = (fetchCode) => {
  return new Promise((resolve, reject) => {
    apiQuery('/authenticated', { loginWithDeviceCode: fetchCode }
    )
      .then(resp => {
        resolve(resp)
      })
  })
}

export const useDeviceCode = (deviceCodeModalProps) => {
  const emptyResult = { deviceLoginToken: undefined,
    deviceFetchCode: undefined,
    deviceCodeTimestamp: undefined }
  const [ result, setResult ] = useState(emptyResult)
  const [ idToken, setIdToken ] = useState(null)

  useEffect(() => {
    const createNewToken = async () => {
      const res = await createDeviceLoginToken()
      if (res && res.deviceLoginToken) {
        setResult(res)
      } else {
        setResult(emptyResult)
      }
    }

    const tokenIsValid = async () => {
      if (!result.deviceLoginToken) {
        return false
      } else {
        const res = await checkIfDeviceCodeValid(result.deviceFetchCode)
        if (res.result !== 1) {
          return false
        }
      }
      return true
    }

    const createNewTokenIfNeeded = async () => {
      const tokenValid = await tokenIsValid()
      if (!tokenValid) {
        await createNewToken()
      }
    }

    const pollCodeLogin = async () => {
      if (deviceCodeModalProps?.open) {
        const tokenValid = await tokenIsValid()
        if (!tokenValid) {
          await createNewToken()
          return
        }

        const response = await loginWithDeviceCode(result.deviceFetchCode)
        if (response.result === 1 && response.id_token) {
          setIdToken(response.id_token)
        }
      }
    }

    createNewTokenIfNeeded()
    const interval = setInterval(pollCodeLogin, 3000)

    return () => clearInterval(interval)
  })

  return { deviceCode: result.deviceLoginToken, fetchToken: result.deviceFetchCode, timestamp: result.deviceCodeTimestamp - 300, idToken: idToken }
}
